(() => {
  const closeAll = (root) => {
    root.querySelectorAll('[data-flashark-menu-item]').forEach((item) => item.classList.remove('is-active'));
    root.querySelectorAll('[data-flashark-mega]').forEach((panel) => {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    });
    root.querySelectorAll('[data-flashark-menu-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
  };

  const openPanel = (root, index) => {
    closeAll(root);
    const item = root.querySelector(`[data-flashark-menu-item][data-menu-index="${index}"]`);
    const panel = root.querySelector(`[data-flashark-mega][data-menu-index="${index}"]`);
    const trigger = item && item.querySelector('[data-flashark-menu-trigger]');
    if (!item || !panel) return;
    item.classList.add('is-active');
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (window.matchMedia('(max-width: 999px)').matches) {
      root.classList.remove('is-categories-open');
      const categoryToggle = root.querySelector('[data-flashark-category-toggle]');
      if (categoryToggle) categoryToggle.setAttribute('aria-expanded', 'false');
      const firstSubmenu = panel.querySelector('[data-flashark-submenu]');
      if (firstSubmenu) activateSubmenu(firstSubmenu);
    }
    root.classList.add('is-menu-open');
  };

  const activateSubmenu = (button) => {
    const mega = button.closest('[data-flashark-mega]');
    if (!mega || button.classList.contains('is-active')) return;
    mega.querySelectorAll('[data-flashark-submenu], [data-flashark-collection]').forEach((element) => element.classList.remove('is-active'));
    button.classList.add('is-active');
    const collection = mega.querySelector(`[data-flashark-collection="${button.dataset.flasharkSubmenu}"]`);
    if (collection) collection.classList.add('is-active');
  };

  const setMobileNavigation = (root, isOpen) => {
    root.classList.toggle('is-mobile-nav-open', isOpen);
    const toggle = root.querySelector('[data-flashark-mobile-menu-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.setAttribute('aria-label', isOpen ? 'Close navigation' : 'Open navigation');
    }
    if (!isOpen) {
      closeAll(root);
      root.classList.remove('is-menu-open', 'is-categories-open');
    }
  };

  const setSearchPanel = (root, isOpen) => {
    const toggle = root.querySelector('[data-flashark-search-toggle]');
    const panel = root.querySelector('[data-flashark-search-panel]');
    if (!panel) return;

    root.classList.toggle('is-search-open', isOpen);
    panel.setAttribute('aria-hidden', String(!isOpen));
    if (toggle) toggle.setAttribute('aria-expanded', String(isOpen));

    if (isOpen) {
      window.setTimeout(() => {
        const input = panel.querySelector('[data-flashark-search-input]');
        if (input) input.focus();
      }, 0);
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-flashark-navigation]').forEach((root) => {
      const mobileToggle = root.querySelector('[data-flashark-mobile-menu-toggle]');
      if (mobileToggle) {
        mobileToggle.addEventListener('click', () => {
          const isOpening = !root.classList.contains('is-mobile-nav-open');
          setMobileNavigation(root, isOpening);
          if (isOpening) {
            const firstTrigger = root.querySelector('[data-flashark-menu-trigger]');
            const firstItem = firstTrigger && firstTrigger.closest('[data-flashark-menu-item]');
            if (firstItem) openPanel(root, firstItem.dataset.menuIndex);
          }
        });
      }

      const searchToggle = root.querySelector('[data-flashark-search-toggle]');
      if (searchToggle) {
        searchToggle.addEventListener('click', () => {
          setSearchPanel(root, !root.classList.contains('is-search-open'));
        });
      }

      root.querySelectorAll('[data-flashark-menu-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          const item = trigger.closest('[data-flashark-menu-item]');
          const index = item.dataset.menuIndex;
          const panel = root.querySelector(`[data-flashark-mega][data-menu-index="${index}"]`);
          if (panel.classList.contains('is-open')) {
            closeAll(root);
            root.classList.remove('is-menu-open');
          } else openPanel(root, index);
        });
      });

      root.querySelectorAll('[data-flashark-menu-item]').forEach((item) => {
        item.addEventListener('mouseenter', () => {
          if (window.matchMedia('(min-width: 1000px)').matches && item.querySelector('[data-flashark-menu-trigger]')) openPanel(root, item.dataset.menuIndex);
        });
      });
      root.addEventListener('mouseleave', () => {
        if (window.matchMedia('(min-width: 1000px)').matches) {
          closeAll(root);
          root.classList.remove('is-menu-open');
        }
      });

      root.querySelectorAll('[data-flashark-submenu]').forEach((button) => {
        button.addEventListener('click', () => activateSubmenu(button));
        button.addEventListener('mouseenter', () => {
          if (window.matchMedia('(min-width: 1000px)').matches) activateSubmenu(button);
        });
      });

      const more = root.querySelector('[data-flashark-category-toggle]');
      if (more) more.addEventListener('click', () => {
        root.classList.toggle('is-categories-open');
        more.setAttribute('aria-expanded', String(root.classList.contains('is-categories-open')));
      });
      root.querySelectorAll('[data-flashark-mobile-top]').forEach((button) => button.addEventListener('click', () => openPanel(root, button.dataset.flasharkMobileTop)));
      root.querySelectorAll('[data-flashark-menu-close]').forEach((button) => button.addEventListener('click', () => {
        closeAll(root);
        setMobileNavigation(root, false);
      }));

      document.addEventListener('click', (event) => {
        if (root.classList.contains('is-search-open') && !root.contains(event.target)) setSearchPanel(root, false);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-flashark-navigation]').forEach((root) => {
        closeAll(root);
        setMobileNavigation(root, false);
        setSearchPanel(root, false);
      });
    });
  });
})();
